import { useEffect } from 'react';

import useCompetitionGenderTypeData from '@usas/ui-web/state/competitionGender/UseCompetitionGenderTypeData';

const useGenderCompetitionCategoryForm = (personState, formState, setFormData) => {
  const { competitionGenderState } = useCompetitionGenderTypeData();

  useEffect(() => {
    if (competitionGenderState.isArrayLoaded === true && personState?.person?.competitionGenderTypeId > 0) {
      const competitionGenderId = personState?.person?.competitionGenderTypeId
      const competitionGenderType = competitionGenderState?.arrayData?.find(x => x.competitionGenderTypeId === personState?.person?.competitionGenderTypeId);
      const competitionGenderTypeDisplayName = competitionGenderType?.displayName || '';
      const competitionGenderTypeName = competitionGenderType?.typeName || '';
      setFormData({
        ...formState,
        competitionGenderTypeId: competitionGenderId,
        competitionGenderTypeDisplayName: competitionGenderTypeDisplayName,
        competitionGenderTypeName: competitionGenderTypeName
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [competitionGenderState.isArrayLoaded]);

  return {
    competitionGenderState
  }
}

export default useGenderCompetitionCategoryForm;